'use strict';

var novicell = novicell || {};

novicell.siteNavigation = novicell.siteNavigation || new function () {
    this.init = function () {
        var siteNavigationToggle = document.getElementById('js-site-navigation-toggle');
        var siteNavigationList = document.getElementById('js-site-navigation-list');
        var topNavigation = document.getElementById('js-top-navigation');
        var topNav = document.querySelector("#js-top-navigation");
        var mainNav = document.querySelector(".site-navigation");

        if (!siteNavigationToggle || !siteNavigationList) {
            return;
        }
        if (!topNav) {
            mainNav.style.top = "0px";
            document.body.style.paddingTop = "100px";
        }

        novicell.subNavigation.init(siteNavigationList);
        
        siteNavigationToggle.addEventListener('click', function (e) {
            e.preventDefault();
            
            novicell.helper.toggleClass(siteNavigationToggle, 'site-navigation-burger--active');
            novicell.helper.toggleClass(siteNavigationList, 'site-navigation-list--open');
            novicell.helper.toggleClass(document.body, 'no-scroll');
            novicell.helper.toggleClass(document.body, 'menu-active');
        });

        if (topNavigation !== null) {
            siteNavigationList.appendChild(topNavigation);
        }
    };
};
